<div class="container">
	<div class="login-body">
		<div id="header-logo">
			<div class="login-section">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
                <img *ngIf="pageDetails?.existsInstituteLogo" class="institute-logo" [src]="pageDetails?.instituteLogoPath" alt="Institute"/>
			</div>
		</div>

		<form id="authorize-form" class="login-form" (keyup.enter)="doAuthorizeSubmit()">
			<div>
				<h1><span id="displayName">
					{{this.display_name || this.client_id}}
				</span> <span jhiTranslate="login.authorize.message">wants to access your BMS Account</span></h1>
			</div>
			<button class="js-authorize-submit login-submit login-flat-control login-clickable" formnovalidate="" type="button"
					(click)="doAuthorizeSubmit()">
				<span class="login-submit-label" jhiTranslate="login.authorize.button">Authorize</span>
			</button>
		</form>

		<div id="footer">
			<div class="login-footer">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-footer-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
				<div class="login-footer-body">
					<span jhiTranslate="about.version.prefix"></span><span [innerText]="version"></span> &bull;
					{{ 'login.provider.message' | translate }} <a href="https://www.integratedbreeding.net/" jhiTranslate="login.provider.ibp">Integrated Breeding Platform</a>
				</div>
			</div>
			<jhi-languange-selector></jhi-languange-selector>
		</div>
	</div>
</div>
